<div class="page-container" [class.loading]="isLoading || !settingsRoleMenuService.areDependenciesLoaded">
    <app-header [title]="roleName" [back]="true" backRoute="/settings/roles" [menuService]="settingsRoleMenuService">
        <div class="buttons">
            <ui-button type="primary" (click)="onChangeAssignments()">
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'settings.role-employees.assignEmployeesButton' | translate }}
            </ui-button>
        </div>
    </app-header>

    <app-kyc-kyb-role-warning [role]="role" />

    @if (table) {
        <ui-card [withMargin]="false" [withSpacing]="false">
            <app-table
                (menuItemSelected)="onTableMenuEvent($event)"
                [isResponsive]="true"
                [showOffset]="true"
                [noPadding]="true"
                [embedded]="true"
                [table]="table"
            >
                <app-empty-state label="settings.role-employees.noEmployeesAssignedMessage" />
            </app-table>
        </ui-card>
    }
</div>

<app-common-bulk-select-employee-dialog
    #appEmployeeSelection
    [label]="'settings.role-employees.assignButton' | translate"
></app-common-bulk-select-employee-dialog>
